import { Box, Heading } from "grommet";
import { useRouter } from "next/router";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import { getArticlesServerSideProps } from "@backend/blog";
import Breadcrumb from "@components/breadcrumb";
import CoinzillaInjection from "@components/coinzilla";
import Layout from "@components/layout";
import Pagination from "@components/pagination";
import getPage from "@helpers/getPage";
import { pageSize } from "@organisms/article/helpers";
import List from "@organisms/article/list";
import Topics from "@organisms/article/topics";

export default function Blog({ articles, totalArticles, categories }) {
  const large = useIsLarge();
  const router = useRouter();
  const page = getPage(router.query.page);

  const onPageChange = (page) => {
    const q = page > 1 && `page=${page}`;

    router.push(`?${q ? q : ""}`, "");
  };

  return (
    <Layout seo={{ title: "Blog", description: "Coinscope's blog spot" }}>
      <Box width={{ width: "100%", max: "xlarge" }} alignSelf="center">
        <Breadcrumb links={[{ label: "Blog", title: "go to Blog" }]} />
        <Box
          margin={{ top: "medium" }}
          flex
          alignSelf={large ? "end" : "center"}
        >
          <CoinzillaInjection />
        </Box>
        <Heading level="1" margin={{ vertical: "large" }}>
          Coinscope Blog
        </Heading>
        <Box
          direction="row"
          align="center"
          gap="small"
          border
          pad={{ horizontal: "small" }}
          round="xsmall"
          overflow={{ horizontal: "auto" }}
        >
          <Heading level="3" margin="none">
            Topics
          </Heading>
          <Topics categories={categories} />
        </Box>
        <Heading level="3" margin={{ top: "large", bottom: "small" }}>
          Articles
        </Heading>
        <List articles={articles} />
        {totalArticles > pageSize && (
          <Pagination
            page={page}
            onChange={onPageChange}
            step={pageSize}
            numberItems={totalArticles}
            margin={{ top: "medium" }}
          />
        )}
      </Box>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  return getArticlesServerSideProps(context);
}
